<template>
    <div class="systembody">
    <div style="margin-top: 10px;">
    <div class="sectionLargeIcon largeServerIcon"></div>
    <div class="widget clearfix">
      <span class="title" style="font-size: 22px; margin-right: 15px; font-weight: 600 !important; color: #183677;">
        Call Reports</span>
      <div class="widget_inside" style="margin-top: 15px;">
        <ReportsComp />
      </div>
    </div>
  </div>
  </div>
  </template>
  <script>
  import ReportsComp from '@/components/callsReport/CallsReportComp'
  import Auth from '@/services/auth.service.js'
  
  export default {
    name: 'upload',
    components: {
      ReportsComp,
    },
    created() {
      document.title = 'Call Reports | clickcall'
      let auth = Auth.checkAuth();
      if (!auth) {
        this.$router.replace({ name: "login" })
      }
    },
  }
  </script>
  <style scoped>
  
  
 
  </style>